import React from 'react';

interface HamburgerIconProps {
  size?: number;
  className?: string;
}

export const HamburgerIcon = ({ size, className }: HamburgerIconProps) => {
  const defaultSize = 48;
  const sizeToUse = size || defaultSize;

  return (
    <svg
      className={className}
      width={sizeToUse}
      height={sizeToUse / 2}
      viewBox="0 0 27 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 25.3875H26.5846V21.2584H0V25.3875ZM0 15.0649H26.5846V10.9359H0V15.0649ZM0 0.613281V4.74231H26.5846V0.613281H0Z"
        fill="white"
      />
    </svg>
  );
};
